module.exports = __webpack_public_path__ + "static/img/yingyonglingyu.dab01b6.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/yingyonglingyu.png
// module id = kap7
// module chunks = 1